import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const BannerContainer = styled.div`
  position: relative;
  background-color: ${theme.surface};
  padding: 130px 0 80px;
  color: white;
  text-align: center;
  overflow: hidden;

  /* Dot grid overlay */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(97,93,255,0.1) 1px, transparent 1px);
    background-size: 32px 32px;
    pointer-events: none;
  }

  /* Gradient blobs */
  &::after {
    content: "";
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    height: 400px;
    background: radial-gradient(ellipse, rgba(97,93,255,0.2) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const Blob = styled.div`
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(80px);

  &.b1 {
    width: 400px; height: 400px;
    top: -100px; right: 5%;
    background: rgba(61,217,235,0.08);
  }
  &.b2 {
    width: 300px; height: 300px;
    bottom: -80px; left: 5%;
    background: rgba(97,93,255,0.12);
  }
`;

const TopLine = styled.div`
  position: absolute;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 50%; height: 1px;
  background: linear-gradient(to right, transparent, rgba(97,93,255,0.5), transparent);
`;

const BannerContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  animation: ${fadeUp} 0.6s ease both;
`;

const Title = styled.h1`
  font-size: clamp(2rem, 5vw, 3rem);
  margin-bottom: 1.25rem;
  font-weight: 800;
  color: ${theme.text};
  letter-spacing: -0.02em;
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  max-width: 580px;
  margin: 0 auto;
  color: ${theme.textMuted};
  line-height: 1.7;
`;

const PageBanner = ({ title, subtitle }) => (
  <BannerContainer>
    <TopLine />
    <Blob className="b1" />
    <Blob className="b2" />
    <BannerContent>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </BannerContent>
  </BannerContainer>
);

export default PageBanner;
